import React from 'react';
import { Skeleton, Space, Layout, Avatar } from 'antd';
import MyHeader from '../Header/Header.module.css';
import classes from "../Toolbar/Toolbar.module.css";
import classes2 from '../Slide/SpeakerNotes/speakerNotes.module.css';
import classesAvatar from '../Avatar/UserAvatar.module.css';

const Loader = () => {
    const { Sider, Content } = Layout;
    return (
        <>
            <div className={MyHeader.headerMain} >
                <Skeleton.Image active style={{ height: '30px', width: '30px', borderRadius: '6px' }} />
                <div className={MyHeader.headerCol}>
                    <Skeleton.Button active style={{ marginLeft: '1rem', width: '160px', height: '24px', borderRadius: '6px' }} />
                </div>
                <div className={MyHeader.titleBarButtons}>
                    <Skeleton.Button active style={{ height: '28px', width: '64px', borderRadius: '6px' }} />
                    <Skeleton.Avatar active size={28} />
                    <Avatar.Group className={classesAvatar.avatar}>
                        <Skeleton.Avatar active size={26} />
                        <Skeleton.Avatar active size={26} />
                    </Avatar.Group>
                </div>
            </div>
            <div className={classes.toolbar} >
                <Space>
                    <Skeleton.Button active style={{ height: '26px', width: '70px', borderRadius: '4px' }} />
                    <Skeleton.Button active style={{ height: '26px', width: '70px', borderRadius: '4px' }} />
                    <Skeleton.Button active style={{ height: '26px', width: '70px', borderRadius: '4px' }} />
                    <Skeleton.Button active style={{ height: '26px', width: '70px', borderRadius: '4px' }} />
                </Space>
            </div>
            <Layout>
                <Layout>
                    <Sider className="sidebar-container" width={window.screen.width < 992 ? '100%' : '13.6%'} >
                        <div style={{ padding: '8px 4px 8px 8px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                            <Skeleton.Button active style={{ height: '80px', width: '100%', borderRadius: '6px' }} />
                            <Skeleton.Button active style={{ height: '80px', width: '100%', borderRadius: '6px' }} />
                            <Skeleton.Button active style={{ height: '80px', width: '100%', borderRadius: '6px' }} />
                            <Skeleton.Button active style={{ height: '80px', width: '100%', borderRadius: '6px' }} />
                        </div>
                    </Sider>
                    <Content id="mainContainer" className='main-container' style={{ backgroundColor: '#f0f2f5', display: 'flex', justifyContent: 'center', paddingTop: '24px', minHeight: 'calc(100vh - 95px)', overflowY: 'auto' }}>
                        <span className="slide-container">
                        <Skeleton.Button className="slide-container" active style={{ width: '100%', height: '100%', borderRadius: '4px' }} />
                        </span>

                        {window.screen.width > 992 &&
                            <div className={classes2.speakerNotesContainer} >

                            </div>
                        }
                    </Content>
                </Layout>
            </Layout>
        </>

    )
}

export default Loader;
